import { Bot, UserCog, HandHeart } from 'lucide-react';
import {
  SERVICE_TIERS as BASE_SERVICE_TIERS,
  type ServiceTier,
} from '../../shared/types/base';
import type { LucideProps } from 'lucide-react';
import type { ForwardRefExoticComponent, RefAttributes } from 'react';

// Icon mapping for UI components
const ICON_MAP: Record<
  string,
  ForwardRefExoticComponent<
    Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>
  >
> = {
  Bot,
  UserCog,
  HandHeart,
};

// UI-specific ServiceTier type with actual React components
export type UIServiceTier = Omit<ServiceTier, 'iconName'> & {
  icon: ForwardRefExoticComponent<
    Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>
  >;
};

// Convert base service tiers to UI service tiers with React components
export const SERVICE_TIERS: UIServiceTier[] = BASE_SERVICE_TIERS.map(tier => ({
  ...tier,
  icon: ICON_MAP[tier.iconName] || Bot, // Fallback to Bot if icon not found
}));

// Export individual tiers for convenience
export const [FULLY_AUTOMATED_TIER, HYBRID_TIER, FULL_PLANNING_TIER] =
  SERVICE_TIERS;
